import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-generic-form-field-group-v2',
    templateUrl: './generic-form-field-group-v2.component.html',
    styleUrls: ['./generic-form-field-group-v2.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class GenericFormFieldGroupV2Component implements OnInit {

  @Input() configData;
  @Input() frmGroup;
  form: any;
  constructor() { }
  
  ngOnInit() {
    console.log("Config Data", this.configData, this.frmGroup);
    // this.setFormFields();
  }

  getForm(event) {
    this.form = event;
    console.log("eventform", event);
    // this.setFormFields();
  }

  getColsClass(cols: number[], control?: any) {
    const mediaBreakpoints = ['xl', 'lg', 'md', 'sm', 'xs'];
    let colsClass = '';
    for (let i = 0; i < cols.length; i++) {
      colsClass += 'col-' + mediaBreakpoints[i] + '-' + cols[i] + ' ';
    }    
    return colsClass;
  }

  createForm(index){
    // return this.frmGroup.get(this.configData.name).controls;
    // return this.frmGroup.controls[this.configData.name]['controls'];
    if(this.frmGroup.controls[this.configData.name].controls.length>1)
      return this.frmGroup.controls[this.configData.name]['controls'][index];
    else
      return this.frmGroup.controls[this.configData.name].controls[0];
  }
  setFormFields() {
    if(this.form) {
        this.form.get("customer").setValue("#Customer Name");
        this.form.get("pickUp").setValue("#PickUp Name");
        this.form.get("dropOff").setValue("#DropOff Name");
        this.form.get("VIN").setValue("############");
        this.form.get("vehicleYear").setValue("Year");
        this.form.get("vehicleMake").setValue("Make");
        this.form.get("vehicleModel").setValue("Model");
      }
    }
}
